import authActions from "@/store/actions/authActions";
import commonActions from "@/store/actions/commonActions";
import eventActions from "@/store/actions/eventActions";
import newsActions from "@/store/actions/newsActions";
import poiActions from "@/store/actions/poiActions";
import kisActions from "@/store/actions/kisActions";
import bookingActions from "@/store/actions/bookingActions";
import adManagerActions from "@/store/actions/adManagerActions";
import llmActions from "@/store/actions/llmActions";
import mapsActions from "@/store/actions/mapsActions";
export default {
  ...authActions,
  ...commonActions,
  ...eventActions,
  ...newsActions,
  ...poiActions,
  ...kisActions,
  ...bookingActions,
  ...adManagerActions,
  ...llmActions,
  ...mapsActions
};
